import React from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type ContactInfoButtonVariant = 'primary' | 'whatsapp' | 'danger'

interface IProps {
  description?: string
  icon: IconProp
  href?: string
  title: string
  onClick?: () => void
  variant?: ContactInfoButtonVariant
}

const variantClassNames: Record<ContactInfoButtonVariant, {
  iconContainer: string
  description: string
}> = {
  primary: {
    iconContainer:
      'bg-action-primary-background text-action-primary-foreground',
    description: 'text-text-primary'
  },
  whatsapp: {
    iconContainer:
      'bg-action-whatsapp-filled-background text-action-whatsapp-filled-foreground',
    description: 'text-text-primary'
  },
  danger: {
    iconContainer:
      'bg-action-destructive-background text-action-destructive-foreground',
    description: 'text-status-danger-foreground'
  }
}

const ContactInfoButton: React.FC<IProps> = props => {
  const variant = props.variant ?? 'primary'
  const variantClasses = variantClassNames[variant]

  if (!props.description) return null

  if (props.href) {
    return (
      <a
        href={props.href}
        target='_blank'
        className={
          'flex items-center cursor-pointer mb-4 flex-col justify-center gap-2 md:flex-row'
        }
        rel='noreferrer'
      >
        <div
          className={`h-[50px] w-[50px] aspect-square rounded-full md:mr-2 md:h-[34px] md:w-[34px] flex items-center justify-center ${variantClasses.iconContainer}`}
        >
          <FontAwesomeIcon
            icon={props.icon}
            size='sm'
          />
        </div>

        <div className='flex flex-col justify-center items-center flex-1 md:items-start'>
          <p className='text-sm text-center'>{props.title}</p>

          <p
            className={`description hidden md:block ${variantClasses.description}`}
          >
            {props.description}
          </p>
        </div>
      </a>
    )
  }

  if (props.onClick) {
    return (
      <button
        type='button'
        onClick={props.onClick}
        className={
          'flex items-center cursor-pointer mb-4 flex-col justify-center gap-2 md:flex-row'
        }
      >
        <div
          className={`h-[50px] w-[50px] aspect-square rounded-full md:mr-2 md:h-[34px] md:w-[34px] flex items-center justify-center ${variantClasses.iconContainer}`}
        >
          <FontAwesomeIcon
            icon={props.icon}
            size='sm'
          />
        </div>

        <div className='flex flex-col justify-center items-center flex-1 md:items-start'>
          <p className='text-sm text-center'>{props.title}</p>

          <p
            className={`description hidden md:block ${variantClasses.description}`}
          >
            {props.description}
          </p>
        </div>
      </button>
    )
  }

  return null
}

export default ContactInfoButton
